export default "__VITE_ASSET__DyEoT07K__"